<template>
  <div class="w-full md:w-4/12 lg:w-3/12 mb-4 lg:mb-10 px-2 lg:px-5 group resource-download">
    <a :href="url" target="_blank" class="flex flex-col space-y-3 p-5 h-full resource-download__inner">
      <div class="flex-auto space-y-3 flex flex-col justify-center text-center">
        <inline-svg
            :src="iconDocument"
            :class="['fill-current mx-auto w-16 h-16', iconClass]"
        ></inline-svg>
        <canvas ref="canvasRef" class="mx-auto w-full h-auto" :class="canvasClass"></canvas>
        <div class="font-bold text-lg leading-tight">{{title}}</div>
        <div v-if="size">{{size}}</div>
      </div>

      <div class="text-center">
        <div class="inline-flex items-center">
          <span class="font-semibold text-brown-thunder">{{type === 'file' ? 'Download' : 'View'}}</span>
          <div
              class="accelerate transform transition-transform duration-200 ease-in group-hover:translate-x-1 ml-2">
            <inline-svg
                :src="linkCaretRight"
                class="text-red-cardinal"
            ></inline-svg>
          </div>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import InlineSvg from 'vue-inline-svg';
import linkCaretRight from '../../../img/icons-svg/link-caret-right.svg';
import iconDocument from '../../../img/icons-svg/document.svg';

// Set up PDF.js worker
pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';

export default {
  name: 'resource-card',
  setup(props) {
    const canvasRef = ref(null);
    const iconClass = ref('');
    const canvasClass = ref('');

    iconClass.value = 'hidden';

    onMounted(async () => {
      try {
        const canvas = canvasRef.value;
        const pdf = await pdfjsLib.getDocument(props.url).promise;
        const page = await pdf.getPage(1);
        const scale = 2.0;
        const viewport = page.getViewport({ scale });

        canvas.height = viewport.height;
        canvas.width = viewport.width;

        await page.render({
          canvasContext: canvas.getContext('2d'),
          viewport,
        }).promise;

        // Hide the icon and display the pdf thumbnail canvas
        iconClass.value = 'hidden';
        canvasClass.value = '';
      } catch {
        // Display the icon and hide pdf thumbnail canvas
        iconClass.value = '';
        canvasClass.value = 'hidden';
      }
    });

    return { linkCaretRight, iconDocument, canvasRef, iconClass, canvasClass };
  },
  components: {
    InlineSvg
  },
  props: {
    title: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: null,
      required: false
    },
    type: {
      type: String,
      default: 'file',
      required: false
    },
    url: {
      type: String,
      required: true
    }
  }
}
</script>